export default "__VITE_ASSET__tw6qxHJk3fzksdW6n_CvaA__"